/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _call_super = require("@swc/helpers/_/_call_super");
var _class_call_check = require("@swc/helpers/_/_class_call_check");
var _create_class = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var Hook = require("./Hook");
var HookCodeFactory = require("./HookCodeFactory");
var SyncBailHookCodeFactory = /*#__PURE__*/ function(HookCodeFactory) {
    _inherits._(SyncBailHookCodeFactory, HookCodeFactory);
    function SyncBailHookCodeFactory() {
        _class_call_check._(this, SyncBailHookCodeFactory);
        return _call_super._(this, SyncBailHookCodeFactory, arguments);
    }
    _create_class._(SyncBailHookCodeFactory, [
        {
            key: "content",
            value: function content(param) {
                var onError = param.onError, onResult = param.onResult, resultReturns = param.resultReturns, onDone = param.onDone, rethrowIfPossible = param.rethrowIfPossible;
                return this.callTapsSeries({
                    onError: (i, err)=>onError(err),
                    onResult: (i, result, next)=>`if(${result} !== undefined) {\n${onResult(result)};\n} else {\n${next()}}\n`,
                    resultReturns,
                    onDone,
                    rethrowIfPossible
                });
            }
        }
    ]);
    return SyncBailHookCodeFactory;
}(HookCodeFactory);
var factory = new SyncBailHookCodeFactory();
var TAP_ASYNC = ()=>{
    throw new Error("tapAsync is not supported on a SyncBailHook");
};
var TAP_PROMISE = ()=>{
    throw new Error("tapPromise is not supported on a SyncBailHook");
};
function COMPILE(options) {
    factory.setup(this, options);
    return factory.create(options);
}
function SyncBailHook() {
    var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], name = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    var hook = new Hook(args, name);
    hook.constructor = SyncBailHook;
    hook.tapAsync = TAP_ASYNC;
    hook.tapPromise = TAP_PROMISE;
    hook.compile = COMPILE;
    return hook;
}
SyncBailHook.prototype = null;
module.exports = SyncBailHook;
